class MemberCreationValidationError extends Error {
    public trace = false;
}

export default MemberCreationValidationError;
